module.exports = __webpack_public_path__ + "static/media/rock-light_thumbnail.12c6fcf4.png";